const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL
  || (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5001'
    : 'https://api.thevastra.store'))
  .trim()
  .replace(/\\n/g, '')
  .replace(/\/+$/, '');

export const getApiUrl = (endpoint) => `${API_BASE_URL}/${String(endpoint).replace(/^\/+/, '')}`;

export { API_BASE_URL }; 